import { UnifiedWithdrawFormTranslations } from "./unified-withdraw-form-pt-br";

export const UNIFIED_WITHDRAW_FORM_FR_FR: UnifiedWithdrawFormTranslations = {
	drawerTitle: "Retrait et Transfert",
	steps: {
		information: "Informations",
		review: "Revue",
	},
	totalBalance: "Solde Total",
	sendTo: "Envoyer à",
	sendToPlaceholder: "Tapez ou sélectionnez le compte",
	addNewAccount: "+ Ajouter un nouveau compte",
	defaultAccountBadge: "Compte par défaut",
	liquidValue: "Valeur Nette",
	liquidValuePlaceholder: "0,00 €",
	reason: "Motif de la demande",
	reasonPlaceholder: "Saisissez le motif du retrait",
	goBack: "Retour",
	goForward: "Suivant",
	submit: "Demander le retrait",
	errorMessage: "Impossible de traiter votre demande. Veuillez réessayer.",
	successMessage: "Votre demande de retrait a été envoyée avec succès !",
	splitBar: {
		available: "Disponible",
		anticipation: "Anticipation",
	},
	totalChipSuffix: "(total)",
	anticipationFee: "Frais d'anticipation",
	thirdPartyFee: "Frais pour compte tiers",
	feeError: {
		message: "Impossible de consulter les frais d'anticipation. Veuillez réessayer.",
		retry: "Réessayer",
	},
	review: {
		valuesReview: "Révision des valeurs",
		typeLabel: "Type",
		typeWithdraw: "Retrait",
		typeWithdrawAndAnticipation: "Retrait + Anticipation",
		statusLabel: "Statut",
		statusPending: "En traitement",
		requestedValue: "Montant demandé",
		anticipatedValue: "Montant anticipé",
		thirdPartyFeeLabel: "Frais pour compte tiers",
		anticipationFeeLabel: "Frais d'anticipation",
		anticipationFeeOnThirdPartyLabel:
			"Frais d'anticipation sur les frais de compte tiers",
		grossValue: "Valeur brute",
		grossValueAnticipation: "Valeur brute à anticiper",
		attentionBannerTitle: "Attention",
		attentionBannerMessage:
			"Les demandes envoyées après 10h30 (heure de Brasília) ne seront traitées que le jour suivant.",
		bankDataTitle: "Coordonnées bancaires",
		holderLabel: "Titulaire du compte",
		accountTypeLabel: "Type de compte",
		agencyLabel: "Agence",
		accountNumberLabel: "Numéro de compte",
		pixKeyLabel: "Clé PIX",
	},
	completion: {
		title: "Tout est en ordre !",
		description: "Le montant demandé est en cours de traitement par l'équipe Financière.",
	},
	partialFailure: {
		modalTitle: "Retrait partiellement traité",
		modalDescription:
			"Le retrait du solde a réussi, mais l'anticipation n'a pas pu être effectuée.",
		title: "Anticipation non effectuée",
		message:
			"Le retrait du solde a réussi, mais l'anticipation a échoué. Veuillez réessayer uniquement l'anticipation.",
		notification:
			"Retrait du solde réussi, mais l'anticipation a échoué. Veuillez réessayer uniquement l'anticipation.",
	},
};
